import React from "react";
import { useState } from "react";
import Flexbox from "flexbox-react";
import { InputGroup, Menu, MenuItem, Icon, Popover, Position } from "@blueprintjs/core";

// import './DepartmentKPITemplates.css';
import { departmentTemplates } from '../../data/departmentKPITemplates.js';

export default function DepartmentKPITemplates({ onSelectDepartment, buttonText = 'Use Templates' }) {
    const [isOpen, setIsOpen] = useState(false);
    const [query, setQuery] = useState("");

    const getPortalContainer = () => {
        if (typeof document === "undefined") return undefined;
        let container = document.getElementById("peoplegoal-portal-container");
        if (!container) {
            container = document.createElement("div");
            container.id = "peoplegoal-portal-container";
            document.body.appendChild(container);
        }
        container.style.position = "absolute";
        container.style.top = "0";
        container.style.left = "0";
        container.style.zIndex = "9999";
        return container;
    };

    const handleClose = () => setIsOpen(false);

    const normalizedQuery = query.trim().toLowerCase();
    const visibleItems = normalizedQuery.length > 0
        ? departmentTemplates.filter(item => (item.name || "").toLowerCase().includes(normalizedQuery) || (item.description || "").toLowerCase().includes(normalizedQuery))
        : departmentTemplates;

    return (
        <div style={{ width: "fit-content" }}>
            <Popover
                isOpen={isOpen}
                onInteraction={(nextOpenState) => setIsOpen(nextOpenState)}
                position={Position.BOTTOM_RIGHT}
                minimal={true}
                portalContainer={getPortalContainer()}
                wrapperTagName="div"
                targetTagName="div"
                content={
                    <div style={{ padding: "8px 0", width: "360px", backgroundColor: "white", borderRadius: "12px", boxShadow: "0 8px 24px rgba(15,23,42,0.12)", border: "1px solid #e6e8eb", overflow: "hidden" }}>
                        <div style={{ padding: "8px 10px", borderBottom: "1px solid #eef0f2", backgroundColor: "white" }}>
                            <InputGroup leftIcon="search" placeholder="Search departments..." value={query} onChange={e => setQuery(e.target.value)} style={{ boxShadow: "none" }} />
                        </div>
                        <div style={{ maxHeight: "320px", overflowY: "auto" }}>
                            <Menu>
                                {visibleItems.length > 0 ? (
                                    visibleItems.map(dept => (
                                        <MenuItem key={dept.id} onClick={() => { onSelectDepartment && onSelectDepartment(dept); handleClose(); setQuery(""); }} text={(
                                            <div style={{ display: "flex", alignItems: "center", gap: "10px", width: "100%" }}>
                                                <div style={{ fontSize: "20px" }}>{dept.icon}</div>
                                                <div style={{ flex: 1 }}>
                                                    <div style={{ fontWeight: 600, color: dept.color, fontSize: 13 }}>{dept.name}</div>
                                                    <div style={{ fontSize: 11, marginTop: 6, lineHeight: "1.3", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }} title={(dept.goals || []).map(g => g.title).join(', ')}>{(dept.goals || []).map(g => g.title).join(', ')}</div>
                                                </div>
                                            </div>
                                        )} />
                                    ))
                                ) : (
                                    <div style={{ padding: "12px", textAlign: "center", fontSize: "13px" }}>No departments found</div>
                                )}
                            </Menu>
                        </div>
                    </div>
                }
            >
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "fit-content", boxSizing: "border-box", padding: "9px 14px", backgroundColor: "white", borderRadius: "20px", cursor: "pointer", boxShadow: "0 0 0 1px #ccc", userSelect: "none" }} onClick={() => setIsOpen(!isOpen)}>
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <Icon icon="plus" iconSize={14} />
                        <span style={{ fontSize: 13, fontWeight: 500, color: "#2e2e2e" }}>{buttonText}</span>
                    </div>
                    <Icon icon="caret-down" iconSize={12} style={{ marginLeft: 6 }} />
                </div>
            </Popover>
        </div>
    );
}

